export const SIGNUP_USER :string = "User/signUp";
export const LOGIN_USER :string = "Authentication/login";
export const GENERATE_OTP : string ="GenerateOtp";
export const VALIDATE_OTP : string ="ValidateOtp";
export const LOGOUT : string= "logOut";
export const GET_LOGIN_METHOD : string= "Setting/useOnlySSO";
